import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'ras-top-banners',
	templateUrl: './top-banners.component.html',
	styleUrls: ['./top-banners.component.sass']
})
export class TopBannersComponent implements OnInit {

	@Input() frontPage = false;

	constructor() { }

	ngOnInit(): void {
	}

}
